<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><router-link to="/clue">线索</router-link></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span><span v-if="cluedeatil.clue_name">{{cluedeatil.clue_name}}</span>
                    <span v-else>--</span></span>
                    <div>未跟进</div>
                </div>

                <div class="back-btn">
                    <a-button @click="back">返回</a-button>
                    <a-button-group>
                        <a-button @click="prev" icon="left" />
                        <a-button @click="next" icon="right" />
                    </a-button-group>
                </div>

                <div class="fieldContainer">
                    <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="cluedeatil.mobile_phone"><a href="javascript:;">{{cluedeatil.mobile_phone}}</a></span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>公司名称：</span>
                        <span v-if="cluedeatil.company_name">{{cluedeatil.company_name}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="cluedeatil.address">{{cluedeatil.address}}</span>
                        <span v-else>--</span>   
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>最近跟进时间：</span>
                        <span v-if="cluedeatil.last_follow_time">{{cluedeatil.last_follow_time}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>预计掉保时间：</span>
                        <span v-if="cluedeatil.deadline">{{cluedeatil.deadline}}</span>
                        <span v-else>--</span>
                    </div>
                </div>
                <div class="labelContainer">
                    <span class="title">标签展示：</span>
                    <div v-if="cluedeatil.tag.length==0">暂无</div>
                    <div v-else class="type-list"><span v-for="(item,idx) in cluedeatil.tag" :key="idx">{{item}}</span></div>

                    <a-dropdown class="labelclue" v-model="typevisible">
                        <a class="ant-dropdown-link" @click="e => e.preventDefault()"><a-icon type="edit" theme="filled"/> 编辑</a>
                        <div slot="overlay">
                            <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChange"
                            />

                            <div class="btnContent">
                                <a-button size="small" @click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div>
                    </a-dropdown>
                </div>

                <div class="btnListContainer" v-if="clueshow">
                    <a-button @click="showgj" type="primary"><a-icon type="snippets" theme="filled"/>写跟进</a-button>
                    <a-button @click="editclue" :id="clueid"><a-icon type="edit" theme="filled"/>编辑</a-button>
                    <a-button @click="showplan"><a-icon type="clock-circle"/>创建计划</a-button>
                    <a-button @click="call(cluedeatil.mobile_phone,clueid)"><a-icon type="phone" theme="filled"/>拨打电话</a-button>
                    <a-button @click="tokh"><a-icon type="swap" />转客户</a-button>
                    
                    <a-button @click="fqshow"><a-icon type="close-circle" theme="filled"/>放弃</a-button>
                    <a-button @click="showbg"><a-icon type="swap"/>变更所属人</a-button>
                    <a-button @click="delclue"><a-icon type="delete"/>删除</a-button>
                </div>

                <div class="btnListContainer" v-if="clueseashow">
                    <a-button ><a-icon type="export" />领取</a-button>
                    <a-button @click="showbg"><a-icon type="share-alt"/>分配</a-button>
                    <a-button @click="delclue"><a-icon type="delete"/>删除</a-button>
                </div>

            </div>
            <div class="lowerInfoContent">
                <a-tabs default-active-key="1" @change="callback">
                    <a-tab-pane key="1" tab="概况信息">
                        <div class="informationLeft">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>基本信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in system_field_list" :key="i" :label="item.name">{{cluedeatil[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>

                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>系统信息</span>
                                </div>
                                 <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in xtsystem_field_list" :key="i" :label="item.name" >{{cluedeatil[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                        </div>
                        <div class="informationRight">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>线索动态</span>
                                </div>

                                <div class="detail-stepsFilter">
                                    <div class="stepsFilter-list">
                                        <span v-for="(item,index) in stepList" :key="index" @click="addClass(index)" :class="index==current? 'isstep':''">{{item.title}}<a-divider type="vertical" /></span>
                                    </div>
                                </div>

                                <a-timeline v-if="gjrecord.length>0">
                                    <div v-for="(item,i) in gjrecord" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.date}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-title">{{followtilte}}</span>
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.add_time}}</span>
                                                    <div>{{item.content}}</div> 
                                                    <!-- <div><p>接通状态：已接听</p></div>
                                                    <div><p>通话对象：万先生</p></div>
                                                    <div class="RecordingAudio"></div> -->

                                                    <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div>
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>

                                    
                                    <!-- <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                    <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item> -->
                                </a-timeline>

                                 <a-empty v-else :image="simpleImage" />
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="线索动态" force-render>
                        <div class="informationRight" style="padding-left:0;margin-left:0">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>线索动态</span>
                                </div>

                                <a-timeline v-if="gjrecord.length>0">
                                    <div v-for="(item,i) in gjrecord" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.date}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-title">{{followtilte}}</span>
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.add_time}}</span>
                                                    <div>{{item.content}}</div> 
                                                    <!-- <div><p>接通状态：已接听</p></div>
                                                    <div><p>通话对象：万先生</p></div>
                                                    <div class="RecordingAudio"></div> -->

                                                    <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div>
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>

                                    
                                    <!-- <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                    <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item> -->
                                </a-timeline>

                                 <a-empty v-else :image="simpleImage" />
                            </div>
                        </div>
                    </a-tab-pane>
         
                </a-tabs>
            </div>
        </div>

        <!-- 写跟进 -->
        <a-modal
        title="新建跟进"
        :visible="gjvisible"
        :confirm-loading="confirmLoading"
        @ok="gjhandleOk"
        @cancel="handleCancel"
        width="610px"
        okText="保存"
        >
            <div class="followLog">
               <a-textarea v-model="gjcontent" placeholder="勤跟进,多签单" :rows="2" />
            </div> 
        </a-modal>

         <!-- 变更所属人 -->
        <a-modal
        title="变更所属人"
        :visible="bgvisible"
        :confirm-loading="confirmLoading"
        @ok="bghandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="保存"
        >
            <div class="bgLog">
                <a-row style="margin-bottom:20px">
                   <a-col :span="5" ><label for="">现有所属人：</label></a-col>
                   <a-col :span="16">
                        <span>程先生</span>
                   </a-col>
               </a-row>
                <a-row>
                   <a-col :span="5" ><label for="" class="required">指定所属人：</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="bghandleChange">
                            <a-select-option v-for="item in bglist" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>

                        </a-select>
                   </a-col>
               </a-row>
            </div> 
        </a-modal>

        
        <!-- 放弃 -->
        <a-modal
        title="放弃"
        :visible="fqvisible"
        :confirm-loading="confirmLoading"
        @ok="fqhandleOk"
        @cancel="handleCancel"
        width="520px"
        okText="确定"
        >
            <div class="fqLog">
               
               <a-row>
                   <a-col :span="5" ><label for="" class="required">放弃原因</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="fqreason">
                            <a-icon slot="suffixIcon" type="smile" />
                            <a-select-option v-for="(item,i) in reason" :key="i" :value="item">
                                {{item}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
               <div style="margin: 24px 46px 0px 92px;">
                   <span>*放弃到公海后此客户数据将属于公共资源，原归属人员不能再维护跟进和更新此客户数据。</span>
               </div>
            </div> 
        </a-modal>

        <!-- 创建计划 -->
        <a-modal
        title="创建计划"
        :visible="planvisible"
        :confirm-loading="confirmLoading"
        @ok="planhandleOk"
        @cancel="handleCancel"
        width="480px"
        okText="保存"
        >
            <div class="planLog">
                <a-row>
                    <a-col  style="text-align:right;margin:0 0 24px" :span="6">
                        <label class="required" for="">计划开始时间：</label>
                    </a-col>
                    <a-col :span="18">
                        <a-date-picker
                            format="YYYY-MM-DD"
                            :disabled-date="disabledDate"
                        />
                    </a-col>
                    </a-row>
                    <a-row>
                    <a-col style="text-align:right" :span="6">
                        <label class="required"  for="">计划内容：</label>
                    </a-col>
                    <a-col :span="18">
                        <a-textarea placeholder="请输入" :rows="5" />
                    </a-col>
                </a-row>
            </div>
        </a-modal>

            <!-- 拨打电话 -->
    <div class="communicate-body" v-if="callshow">
        <div>
            <div class="communicate-head">
                <a-dropdown>
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                    <img src="../../../static/svg/drop.svg" alt="">
                    <span>4G全网通</span>
                    </a>
                    <a-menu slot="overlay">
                    <a-menu-item>1st menu item</a-menu-item>
                    <a-menu-item>2nd menu item</a-menu-item>
                    <a-sub-menu key="test" title="sub menu">
                        <a-menu-item>3rd menu item</a-menu-item>
                        <a-menu-item>4th menu item</a-menu-item>
                    </a-sub-menu>
                    </a-menu>
                </a-dropdown>

                <div class="communicate-close" @click="closecall">
                    <img src="../../../static/svg/close.svg" alt="">
                </div>
            </div>
        </div>

   

      <div class="communicate-body-oper">
        <div :style="{display:show1}" class="communicate-oper" id="success" >
            <div class="number-input">
                <img src="../../../static/svg/call.svg" alt="">
                <a-input autocomplete="off" v-model="phone" placeholder="请输入电话号码" style="font-size: 18px;"></a-input>
            </div>

            <div class="communicate-key">
                <div class="keyboard-box" @click.stop='handleKeyPress'>
                <span class="keyboard-btn" data-num='1'>1</span>
                <span class="keyboard-btn" data-num='2'>2</span>
                <span class="keyboard-btn" data-num='3'>3</span>
                <span class="keyboard-btn" data-num='4'>4</span>
                <span class="keyboard-btn" data-num='5'>5</span>
                <span class="keyboard-btn" data-num='6'>6</span>
                <span class="keyboard-btn" data-num='7'>7</span>
                <span class="keyboard-btn" data-num='8'>8</span>
                <span class="keyboard-btn" data-num='9'>9</span>
                <span class="keyboard-btn" data-num='*'>*</span>
                <span class="keyboard-btn" data-num='0'>0</span>
                <span class="keyboard-btn" data-num='#'>#</span>
                </div>

                <div class="communicate-call-btn" >
                <!-- <a-button type="primary">了解更多</a-button> -->
                <img src="../../../static/svg/down.svg"  @click="totel" alt="">
                <img class="totell" src="../../../static/svg/callbtn.svg"  @click="totel" alt="">
                <img src="../../../static/svg/delphone.svg"  @click="totel" alt="">
                <!-- <a-button @click="totel">拨打电话</a-button> -->
                </div>
            </div>
        </div>

        <div :style="{display:show2}" class="load-communicate" id="loading">
            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

            <div class="communicate-record">
                <div class="head-top">
                    <span>{{cluedetail.clue_name}}</span>
                    <div class="labelContainer">
                        <div v-if="cluedetail.tag.length>0">--</div>
                        <div v-else class="type-list"><span v-for="(item,idx) in cluedetail.tag" :key="idx">{{item}}</span></div>
                       
                    </div>
                    <a-dropdown :trigger="['click']" v-model="typevisible">
                        <span class="ant-dropdown-link add-type" @click="e => e.preventDefault()">
                            + 标签
                        </span>
                        <div slot="overlay" class="tags-panel">
                            <div class="tags-panel-title">设置标签</div>
                             <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChangetype"
                            />

                            <div class="btnContent">
                                <a-button size="small" click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div> 
                    </a-dropdown>

                    <a-textarea v-model="gjcontent" placeholder="勤写跟进，多赢单，限定500个字" :rows="4" />
                    <a-button  class="savephone" @click="gjhandleOk">保存</a-button>
                    
                </div>
            </div>
        </div>

        <div :style="{display:show3}" class="fail-communicate-oper" id="fail" >
            <img src="../../../static/svg/fail_work.svg" alt="" >
            <h1>目前话机无法正常工作，检查后重试</h1>
            <div>
              <p>1、检测话机是否正常运作，如断电、死机</p>
              <p>2、检测话机与电脑的连接是否正常，建议重新插拔USB设备，更换USB接口或数据线</p>
            </div>
        </div>

        <div :style="{display:show4}" class="exp" id="blockpage">
            <a-spin />
        </div>
      </div>

    </div>
    </div>
</template>
<style>
.ant-dropdown-content{
    width: 140px;
    padding: 10px 12px 4px;box-sizing: border-box
}
.ant-dropdown{background: #fff;box-shadow: 0 2px 8px rgba(0,0,0,.15);}
.ant-dropdown-content .ant-checkbox-group label{
    margin-bottom: 6px;
    display: block;
    margin-right: 0;
    font-size: 13px;
}
.btnContent{
    height: 36px;
    text-align: center;
    border-top: 1px solid #ededed;
    padding: 8px 10px 0px ;
}
.btnContent button{font-size:12px}

.isstep {
    color: #4f7afd!important;
}
</style>
</style>

<script>
import { Modal } from 'ant-design-vue';
import moment from 'moment';
import { Empty } from 'ant-design-vue';
// const plainOptions = ['KA客户', '无效资源', '无合作意向'];
const columns = [
  {
    title: '联系人',
    dataIndex: 'contact_name',
    key: 'contact_name',
    scopedSlots: { customRender: 'contact_name' },
  },
  {
    title: '手机',
    dataIndex: 'mobile_phone',
    key: 'mobile_phone',
  },
  {
    title: '职务',
    dataIndex: 'role',
    key: 'role',
    ellipsis: true,
  },
];
const columns2 = [
  {
    title: '商机标题',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '预计成交金额(¥)',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '预计成交时间',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true,
  },
   {
    title: '销售阶段',
    dataIndex: 'jd',
    key: 'jd',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '阶段百分比',
    dataIndex: 'perect',
    key: 'perect',
  },
  {
    title: '意向产品',
    dataIndex: 'yx',
    key: 'yx 1',
    ellipsis: true,
  },
];
const data2 = [
  {
    key: '1',
    name: 'John Brown',
    age: 18759865674,
    address: 'New York No. 1 Lake Park, New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 18759865674,
    address: 'London No. 2 Lake Park, London No. 2 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 18759865674,
    address: 'Sidney No. 1 Lake Park, Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];
export default {
    data(){
        return{
            current:0,
            plainOptions:[],
            value: [],
            columns,
            columns2,
            data2,
            gjvisible:false,
            planvisible:false,
            fqvisible:false,
            bgvisible:false,
            confirmLoading:false,
            bglist:"",
            bgid:"",
            reason:"",
            cause_of_abandonment:"",
            gjcontent:"",
            clueid:"",
            cluedeatil:"",
            system_field_list:"",
            xtsystem_field_list:"",
            lxdata:[],
            stepList:[
                {title:'全部'},
                {title:'跟进记录'},
                {title:'跟进行为'},
                {title:'操作日志'}
            ],
            clueshow:true,
            clueseashow:false,
            tags:[],
            typevisible:false,
            
            gjrecord:"",
            followtilte:"",
            type:1,

            menulist:"",
            userinfo:"",
            search:"",
            phone:"",
            callshow:false,
            cluedetail:"",
            plainOptions:[],
            tags:[],
            phoneid:"",
            typevisible:false,
            value: [],

            simlist:[],
        }
    },
    beforeCreate() {
        this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    },
    mounted(){

        this.getfollow()
        
        this.clueid=this.$route.query.id
        var cluetype=this.$route.query.type
        if(cluetype==1){
            this.type=2
            this.clueshow=false,
            this.clueseashow=true
        }

        // 标签列表
        this.$axios.get("/api/getdatatags",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                this.plainOptions=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        }),

        // 线索详情
        this.$axios.get("/api/getdatadetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:this.clueid,
                datatype:this.type
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.lxdata=res.data.data.contact_info
                this.cluedeatil=res.data.data.info
            }else{
                this.$message.error(res.data.msg);
            }
        }),

         // 字段
        this.$axios.get('/api/datafieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
            }else{
                this.$message.warning(res.data.msg);
            }
        }),
        this.$axios.get('/api/datafieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:2
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.xtsystem_field_list=data2
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

        this.$axios.get("/api/userlist",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.bglist=res.data.data.lists
            }
        }),

        // 放弃原因
        this.$axios.get("/api/dropreason",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.reason=res.data.data
            }
        })

    },
    methods:{
        moment,

        totel(){

        },
         // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChangetype(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.get("/api/setdatatags",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    data_id:this.phoneid,
                    tag:this.tags
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.$axios.get("/api/getdatatags",{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.plainOptions=res.data.data
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        //处理按键
        handleKeyPress(e) {
            let num = e.target.dataset.num;
            this.phone=this.phone+num
        },
        call(value,clueid){
            // console.log(clueid)
            this.$axios.get("/api/getsipinfo",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    user_id:localStorage.getItem('userid')
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var type=res.data.data.call_methods
                    this.siptype=type
                    console.log("type="+type)
                    if(type==2){
                        var simStatus= simlist()
                        var nowsim=currsim()  
                            if(simStatus!=undefined){
                            simStatus=simStatus.split(",")
                            }

                        for(var i in simStatus){
                        if(simStatus[i]==0){
                            this.simlist[i]=true
                        }else{
                            this.simlist[i]=false
                        }
                        } 
                        this.currentsim=nowsim

                        this.phoneid=clueid
                        // console.log("id="+this.phoneid)
                        var id=clueid
                        this.callshow=!this.callshow,
                        this.phone=value
                        var link=linktype()
                        if(link==2){
                            // alert(link)
                            this.show2='none'
                            this.show1='none'
                            this.show3='block'
                            this.show4='none'
                        }else{
                            callfixed(id,1,value)
                            this.show4='none'
                            this.show1='none'
                            this.show3='none'
                            this.show2='block'

                            this.$axios.get("/api/getdatadetail",{
                                headers: {
                                    "appid": this.appSet.appid,
                                    "appkey": this.appSet.appkey,
                                    "token":localStorage.getItem('token'),
                                },
                                params:{
                                    id:id,
                                }
                            }).then((res)=>{
                                if(res.data.code==200){
                                    this.cluedetail=res.data.data.info
                                }else{
                                    this.$message.error(res.data.msg);
                                }
                            })
                        }

                    }
                    else if(type==1){
                        this.show1='block'
                        this.show4='none'
                        this.callshow=!this.callshow,
                        this.phone=value
                        // alert(this.callshow)
                    }
                }
            })

        },
        total(){

        },
        
        closecall(){
            this.callshow=false
        },

        getfollow(){
            this.$axios.get("/api/followlist",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    data_id:this.$route.query.id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjrecord=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },

        // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChange(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.post("/api/setdatatags",{
                    data_id:this.$route.query.id,
                    tag:this.tags
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.getfollow()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        
        getdetail(value){
            this.$axios.get("/api/getdatadetail",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token')
                },
                params:{
                    id:this.cluedeatil.id,
                    selecttype:value
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.lxdata=res.data.data.contact_info
                    this.cluedeatil=res.data.data.info
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 上一个
        prev(){
            var value='prev'
           this.getdetail(value)
        },
        // 下一个
        next(){
            var value='next'
            this.getdetail(value)
        },
        // 转客户
        tokh(){
            var id=this.$route.query.id
            this.$router.push({path: '/cluetokh',query:{ id:id}});
        },

        // 编辑
        editclue(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/edit',query:{ id:id}});
        },

        disabledDate(current) {
            return current < moment().endOf('day');
        },
        bghandleChange(value){
            this.bgid=value
        },

        back(){
            this.$router.go(-1);//返回上一层
        },
        showgj(){
            this.gjvisible=true
        },
        showbg(){
            this.bgvisible=true
        },
        showplan(){
            this.planvisible=true
        },
        fqshow(){
            this.fqvisible=true
        },
        handleCancel(){
            this.gjvisible=false
            this.planvisible=false
            this.fqvisible=false
            this.bgvisible=false
        },
        // 跟进
        gjhandleOk(){
            this.$axios.get("/api/addfollow",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    content:this.gjcontent,
                    data_id:this.$route.query.id,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjvisible=false
                    this.$message.success(res.data.msg); 
                    this.getfollow()
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 计划
        planhandleOk(){
            
        },
        // 变更
        bghandleOk(){
            this.$axios.get("/api/setdatabelong",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:this.$route.query.id,
                    user_id:this.bgid
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 放弃
        fqreason(value){
            this.cause_of_abandonment=value
        },
        fqhandleOk(){
            this.$axios.get("/api/dropdata",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:this.$route.query.id,
                    cause_of_abandonment:this.cause_of_abandonment
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        addClass(index){
            this.current=index
            if(index==1){
                this.getfollow()
                this.followtilte="写跟进"
            }
        },
        // 删除
        delclue() {
            Modal.confirm({
                title: '提示',
                content: '您确定删除此菜单吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok()
                },
                onCancel() {

                },
            });
        },

        handok(){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delmenu',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
     
            })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/customer/cluedetail.vue